(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-auth-styles"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-password-toggle]').forEach((toggle) => {
    const input = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!input) return;
    toggle.addEventListener('click', () => {
      const passwordIsVisible = input.type === 'text';
      input.type = passwordIsVisible ? 'password' : 'text';
      input.dataset.passwordVisible = passwordIsVisible ? 'false' : 'true';
      toggle.setAttribute('aria-pressed', passwordIsVisible ? 'false' : 'true');
      toggle.setAttribute('aria-label', passwordIsVisible ? toggle.dataset.showLabel : toggle.dataset.hideLabel);
    });
  });

  document.querySelectorAll('.account-auth__register-form').forEach((form) => {
    const password = form.querySelector('#RegisterForm-password');
    const confirmation = form.querySelector('[data-password-confirmation]');
    if (!password || !confirmation) return;
    const validate = () =>
      confirmation.setCustomValidity(
        confirmation.value === password.value ? '' : confirmation.dataset.passwordMismatch
      );
    password.addEventListener('input', validate);
    confirmation.addEventListener('input', validate);
    form.addEventListener('submit', (event) => {
      validate();
      if (!confirmation.checkValidity()) {
        event.preventDefault();
        confirmation.reportValidity();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-tabbed-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabbed-mega-menu')) {
    customElements.define(
      'tabbed-mega-menu',
      class TabbedMegaMenu extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.headingTargets = Array.from(this.querySelectorAll('[data-heading-target]'));
          this.querySelectorAll('.tabbed-mega-menu__products').forEach((track) => {
            let origin = null,
              scroll = 0,
              dragged = false;
            track.addEventListener('pointerdown', (e) => {
              dragged = false;
              if (
                e.pointerType !== 'mouse' ||
                e.button !== 0 ||
                e.target.closest('tabbed-product-gallery,button,input,select')
              )
                return;
              origin = e.clientX;
              scroll = track.scrollLeft;
              dragged = false;
            });
            track.addEventListener('pointermove', (e) => {
              if (origin === null) return;
              if (Math.abs(e.clientX - origin) > 8) {
                dragged = true;
                track.classList.add('is-dragging');
                track.setPointerCapture(e.pointerId);
                track.scrollLeft = scroll - (e.clientX - origin);
              }
            });
            const finish = (e) => {
              origin = null;
              track.classList.remove('is-dragging');
              if (track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
            };
            track.addEventListener('pointerup', finish);
            track.addEventListener('pointercancel', finish);
            track.addEventListener('lostpointercapture', () => {
              origin = null;
              track.classList.remove('is-dragging');
            });
            track.addEventListener('dragstart', (e) => e.preventDefault());
            track.addEventListener(
              'click',
              (e) => {
                if (dragged) {
                  e.preventDefault();
                  e.stopPropagation();
                  dragged = false;
                }
              },
              true
            );
            track.tabIndex = 0;
            track.addEventListener('keydown', (e) => {
              if (e.target === track && ['ArrowLeft', 'ArrowRight'].includes(e.key)) {
                e.preventDefault();
                track.scrollBy({ left: track.clientWidth * (e.key === 'ArrowRight' ? 1 : -1), behavior: 'smooth' });
              }
            });
          });
          if (this.classList.contains('tabbed-mega-menu--mobile')) {
            const button = this.querySelector('.tabbed-mega-menu__button');
            if (button) this.querySelector('.tabbed-mega-menu__layout').append(button);
          } else {
            const disclosure = this.closest('.tabbed-mega-menu-disclosure');
            const summary = disclosure?.querySelector('summary');
            const content = disclosure?.querySelector('.tabbed-mega-menu-content');
            const menuLink = summary?.querySelector('.tabbed-mega-menu__menu-link');
            const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

            if (disclosure && summary && content) {
              let closeTimer;
              const openMenu = () => {
                if (!finePointer.matches) return;
                window.clearTimeout(closeTimer);
                disclosure.open = true;
                summary.setAttribute('aria-expanded', 'true');
              };
              const scheduleClose = () => {
                if (!finePointer.matches) return;
                window.clearTimeout(closeTimer);
                closeTimer = window.setTimeout(() => {
                  disclosure.open = false;
                  summary.setAttribute('aria-expanded', 'false');
                }, 200);
              };

              summary.addEventListener('mouseenter', openMenu);
              summary.addEventListener('mouseleave', scheduleClose);
              content.addEventListener('mouseenter', openMenu);
              content.addEventListener('mouseleave', scheduleClose);
              menuLink?.addEventListener('click', (event) => event.stopPropagation());
            }
          }
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
          });
        }

        activate(activeTab) {
          this.setAttribute('data-products-open', '');
          const activeIndex = activeTab.dataset.tab;
          this.tabs.forEach((tab) => {
            const selected = tab === activeTab;
            tab.classList.toggle('is-active', selected);
            tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            tab.tabIndex = selected ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            const selected = panel.dataset.panel === activeIndex;
            panel.classList.toggle('is-active', selected);
            panel.hidden = !selected;
          });
          this.headingTargets.forEach((target) => {
            target.hidden = target.dataset.headingTarget !== activeIndex;
          });
        }

        onKeydown(event, currentTab) {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
          const currentIndex = this.tabs.indexOf(currentTab);
          const nextIndex =
            event.key === 'Home'
              ? 0
              : event.key === 'End'
              ? this.tabs.length - 1
              : (currentIndex + direction + this.tabs.length) % this.tabs.length;
          this.tabs[nextIndex].focus();
          this.activate(this.tabs[nextIndex]);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-buy-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-buy-button')) {
    customElements.define(
      'sticky-buy-button',
      class StickyBuyButton extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.getElementById(this.dataset.mainButtonId);
          this.hasPassedMainButton = false;
          this.footerVisible = false;
          this.isSelected = false;
          this.handleClick = this.handleClick.bind(this);
          this.updateViewportGutter = () => {
            const gutter = window.matchMedia('(max-width: 749px)').matches
              ? Math.max(0, window.innerWidth - document.documentElement.clientWidth)
              : 0;
            this.style.setProperty('--sticky-buy-viewport-gutter', `${gutter}px`);
          };
          this.addEventListener('click', this.handleClick);
          window.addEventListener('resize', this.updateViewportGutter);
          this.updateViewportGutter();

          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;

            const source = event.data.html.getElementById(`StickyBuyContent-${this.dataset.sectionId}`);
            const destination = this.querySelector(`#StickyBuyContent-${this.dataset.sectionId}`);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });

          if (this.mainButton) {
            this.buttonStateObserver = new MutationObserver(() => this.syncButtonState());
            this.buttonStateObserver.observe(this.mainButton, {
              attributes: true,
              attributeFilter: ['disabled', 'aria-disabled'],
            });
            this.syncButtonState();

            this.visibilityObserver = new IntersectionObserver(([entry]) => {
              this.hasPassedMainButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
              this.updateVisibility();
            });
            this.visibilityObserver.observe(this.mainButton);
          }

          this.footer = document.querySelector('footer.footer');
          if (this.footer) {
            const footerRect = this.footer.getBoundingClientRect();
            this.footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
            this.footerObserver = new IntersectionObserver(([entry]) => {
              this.footerVisible = entry.isIntersecting;
              this.updateVisibility();
            });
            this.footerObserver.observe(this.footer);
          }

          this.handleBlockSelect = (event) => {
            if (event.target !== this) return;
            this.isSelected = true;
            this.updateVisibility();
          };
          this.handleBlockDeselect = (event) => {
            if (event.target !== this) return;
            this.isSelected = false;
            this.updateVisibility();
          };
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          window.removeEventListener('resize', this.updateViewportGutter);
          this.buttonStateObserver?.disconnect();
          this.visibilityObserver?.disconnect();
          this.footerObserver?.disconnect();
          this.variantChangeUnsubscriber?.();
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        }

        handleClick(event) {
          const button = event.target.closest('.sticky-buy-button__button');
          if (!button) return;

          event.preventDefault();
          if (!this.mainButton || this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true')
            return;
          this.mainButton.click();
        }

        syncButtonState() {
          const button = this.querySelector('.sticky-buy-button__button');
          if (!button || !this.mainButton) return;

          button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        }

        updateVisibility() {
          const show = (this.hasPassedMainButton || this.isSelected) && !this.footerVisible;
          this.hidden = false;
          this.classList.toggle('is-visible', show);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabbed-menu-product-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabbed-product-gallery'))
    customElements.define(
      'tabbed-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
        }
      }
    );
  } catch(e) { console.error(e); }
})();

})();
